var plupload =require ('plupload')
module.exports= function(obj){
    var serverUrl = obj.serverUrl;
    var accessid = '';
    var host = '';
    var policyBase64 = '';
    var signature = '';
    var filemap = new Array();
    var dir = '';
    var expire = 0;
    var g_object_name = '';
    var timestamp = 0;

    function initParam () {
        timestamp = Date.parse(new Date()) / 1000;
        if (expire < timestamp) {
            var body = send_request(serverUrl);
            var obj = eval ("(" + body + ")");
            var data = obj;
            host = data['host'];
            policyBase64 = data['policy'];
            accessid = data['accessid'];
            signature = data['signature'];
            expire = parseInt(data['expire']);
            dir = data['dir'];
            return true;
        }
        return false;
    }

    function send_request(url){
        var xmlhttp = null;
        if (window.XMLHttpRequest)
        {
            xmlhttp=new XMLHttpRequest();
        }
        // else if (window.ActiveXObject)
        // {
        //     xmlhttp=new ActiveXObject("Microsoft.XMLHTTP");
        // }

        if (xmlhttp!=null)
        {
            xmlhttp.open( "GET", url, false );
            xmlhttp.send( null );
            return xmlhttp.responseText
        }
        else
        {
            alert("Your browser does not support XMLHTTP.");
        }
    }

    function get_suffix(filename) {
        var pos = filename.lastIndexOf('.');
        var suffix = '';
        if (pos != -1) {
            suffix = filename.substring(pos)
        }
        return suffix;
    }

    function random_string(len)
    {
        len = len || 32;
        var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
        var maxPos = chars.length;
        var pwd = '';
        for(var i=0;i<len;i++){
            pwd += chars.charAt(Math.floor(Math.random() * maxPos));
        }
        return pwd;
    }

    function set_upload_param(up, filename, ret)
    {
        if (ret == false)
        {
            ret = initParam()
        }
        g_object_name = dir;
        if (filename != '') {
            var suffix = get_suffix(filename);
            g_object_name = dir + random_string(10) + suffix;
            filemap[filename] = g_object_name;
        }
        var new_multipart_params = {
            'key' : g_object_name,
            'policy': policyBase64,
            'OSSAccessKeyId': accessid,
            'success_action_status' : '200', //让服务端返回200,不然，默认会返回204
            'signature': signature
        };

        up.setOption({
            'url': host,
            'multipart_params': new_multipart_params
        });

        (typeof obj.direct == 'undefined' || obj.direct) && up.start();
    }

    var uploader = new plupload.Uploader({
        runtimes : 'html5',
        browse_button : obj.upload_button,
        multi_selection: obj.multi || false,
        url : 'dangdangshejiao.oss-cn-beijing.aliyuncs.com/',
        filters: {
            mime_types : [
                { title : "files", extensions : obj.extensions },
            ],
            max_file_size : obj.max,
            prevent_duplicates : false
        },
        init: {
            PostInit: function() {

            },

            FilesAdded: function(up, files) {
                set_upload_param(up, '', false);
                obj.added && obj.added(up, files);
            },

            BeforeUpload: function(up, file) {
                set_upload_param(up, file.name, true);
                obj.beforeUpload && obj.beforeUpload(file);
            },

            UploadProgress: function(up, file) {
                obj.progress && obj.progress(file.name, file.percent, file);
            },

            FileUploaded: function(up, file, info) {
                if (info.status == 200) {
                    obj.success(host + '/' + filemap[file.name], file, info);
                } else {
                    obj.error(info.response);
                }
            },

            Error: function(up, err) {
                if (err.code == -600) {
                    obj.error("文件过大，请选择小于"+ obj.max +"的文件");
                }else if (err.code == -601) {
                    obj.error("请选择正确的文件格式，例如：" + obj.extensions);
                }else if (err.code == -602) {
                    obj.error("文件不得重复上传");
                }else if (err.code == -200){
                    obj.error("上传签名有效期已过");
                }else
                {
                    obj.error("Error xml:" + err.message);
                }
            }
        }
    });

    uploader.init();

    return uploader;
};
